import customTailwindConfig from '../../tailwind.config.js'
import resolveTailwindConfig from 'tailwindcss/resolveConfig'

export const tailwindConfig = resolveTailwindConfig(customTailwindConfig)

export function $get(object, path, def, separator) {
    try {
        separator = separator || '.'

        return path
            .replace('[', separator)
            .replace(']', '')
            .split(separator)
            .reduce(function(obj, property) {
                if (typeof obj[property] === 'undefined') {
                    if (typeof def !== 'undefined') {
                        return def
                    }
                    return undefined
                }

                return obj[property]
            }, object)
    } catch (err) {
        return typeof def !== 'undefined' ? def : undefined
    }
}

export function $set(object, path, value) {
    let parts = path
        .replace('[', '.')
        .replace(']', '')
        .split('.')

    let key = parts.pop()

    return Vue.set(parts.reduce((tempObj, property) => tempObj[property], object), key, value)
}

export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1)
}

export function empty(value) {
    return typeof value === 'undefined' || value === null
}

export function optional(test, callback) {
    return empty(test) ? value(callback) : test
}

export function redirect(url, options) {
    Bus.$emit('page.redirect', {
        url: url,
        options: typeof options === 'undefined' ? {} : options,
    })
    setTimeout(() => (window.location = url), 250)
}

export function value(value) {
    return typeof value === 'function' ? value() : value
}
